export const appVersion = '0.35.1';
